exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".disableInput{\n    pointer-events:none;\n    background-color: #f3f7f9;\n}\n.sugget-container{\n    position: absolute;\n    max-height: 230px;\n    max-width: 454px;\n    min-width: 150px;\n    z-index: 999;\n    margin-top: 5px;\n    background: #fff;\n    box-shadow: 0px 2px 11px #afabab;\n    overflow-y: auto\n}\n.sugget-container > ul > li:hover{\n    cursor: pointer;\n    background: #fafafa\n}\n.sugget-background{\n    position: fixed;\n    z-index: 998;\n    width: 100%;\n    height: 100%;\n    top: 0px;\n    left: 0px;\n    background: transparent\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/app/pages/admin/qrcode/popup/modalDistribution.css
// module id = ../../../../../src/app/pages/admin/qrcode/popup/modalDistribution.css
// module chunks = 3